import KassaHisobot from "./KassaHisobot";
import RestrKassa from "./RestrKassa";

export default () => {
  return [KassaHisobot, RestrKassa];
};
